import Reveal from "@/components/base/Reveal";

export default function CtaBand() {
  return (
    <section className="bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <Reveal>
        <div className="mx-auto w-full max-w-shell overflow-hidden rounded-lg bg-primary-600 px-6 py-12 md:px-12 md:py-16">
          <div className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-flashlight-fill" />
                现在就能开始
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
                了解完功能与板块，直接去逛逛
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-background-50/80 md:text-base">
                黑料平台功能、内容板块与玩法机制都在这里讲清楚了。接下来挑一个感兴趣的板块进去，或者订阅话题，等更新来找你。
              </p>
            </div>
            <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
              <a
                href="#sections"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
              >
                进入内容板块
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="#how"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/50 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
              >
                再看玩法机制
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}